import { Table_Tr_default } from "./chunk-6OB5YQSK.js";
import { Table_default } from "./chunk-ZHOIIIHU.js";
import { Table_Tbody_default } from "./chunk-MORVNIV4.js";
import { Table_Td_default } from "./chunk-EGF6FHA2.js";
import { Table_Th_default } from "./chunk-2JM2ZTBD.js";
import { Table_Thead_default } from "./chunk-DTDKB32A.js";

// src/elements/Table/index.ts
var TableComponent = Table_default;
TableComponent.Thead = Table_Thead_default;
TableComponent.Thead.displayName = "Table.Thead";
TableComponent.Tbody = Table_Tbody_default;
TableComponent.Tbody.displayName = "Table.Tbody";
TableComponent.Tr = Table_Tr_default;
TableComponent.Tr.displayName = "Table.Tr";
TableComponent.Th = Table_Th_default;
TableComponent.Th.displayName = "Table.Th";
TableComponent.Td = Table_Td_default;
TableComponent.Td.displayName = "Table.Td";
export { TableComponent };